// extracted by mini-css-extract-plugin
export default {"canvas":"canvas_canvas__+-LUw"};